module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _c('strong', [_vm._v("ST. TROPEZ"), _c('br'), _c('span', {
    staticClass: "underline"
  }, [_vm._v("SUMMER RENTAL")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('strong', [_vm._v("By month or longer term.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('strong', [_vm._v("Charming traditional stone villa built around an ancient"), _c('br'), _vm._v("priory. Sunny terraces, mosaic-tiled swimming pool, arched"), _c('br'), _vm._v("courtyard with olive trees, lavish secluded grounds"), _c('br'), _vm._v("overlooking pine-treed hillside with direct view of the sea.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('strong', [_vm._v("Five bedrooms, five baths. Beautifully furnished. Well-equipped"), _c('br'), _vm._v("kitchen. Staff available if required.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('strong', [_vm._v("Perfectly private.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('strong', [_vm._v("For brochure with photographs and further details, contact:"), _c('br'), _vm._v("MadameSusanneLariotCannes@wanadoo.france")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d139c4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0